import { API, authClient } from '../index'

// Get all projects
export const getAllActiveProjects = () => {
    return authClient().get(`${API}/project/`)
}
// Get all projects
export const getAllProjects = () => {
    return authClient().get(`${API}/project/?getDisabled=true`)
}

// Get project by id
export const getProjectById = (id) => {
    return authClient().get(`${API}/project/${id}`)
}

// Create project
export const postProject = async (project) => {
    return authClient().post(`${API}/project/`, project)
}

// Update text
export const updateProject = (id, project) => {
    return authClient().put(`${API}/project/${id}`, project)
}
// Change status project
export const changeStatusProjectStatus = async (id, active) => {
    return authClient().put(`${API}/project/change-status/${id}`, { active });
};

export const changeHighlightedProject = async (id, highlighted) => {
    return authClient().put(`${API}/project/change-highlighted/${id}`, { highlighted });
};


// Change validate project
export const changeValidateProjectStatus = async (id, validated, descriptionRejected) => {
    return authClient().put(`${API}/project/change-validate/${id}`, { validated, descriptionRejected });
};


// Delete project
export const deleteProject = (id) => {
    return authClient().delete(`${API}/project/${id}`)
}

// Upload manual teaser
export const uploadManualTeaser = (id, file) => {
    if (!file) {
        return Promise.reject(new Error('File must be provided'));
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', 'projects/manual-teasers');
    return authClient().post(`${API}/project/${id}/manual-teaser`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

// Delete manual teaser
export const deleteManualTeaser = (id) => {
    return authClient().delete(`${API}/project/${id}/manual-teaser`);
};